import {Component, Input, OnDestroy} from '@angular/core';
import {Subscription} from "rxjs";

@Component({
    selector: 'app-gather-header',
    templateUrl: './gather-header.component.html',
    styleUrls: ['./gather-header.component.scss'],
    standalone: false
})
export class GatherHeaderComponent implements OnDestroy {
  @Input() headerText: String

  private subscriptions = new Subscription();

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
